import { render, staticRenderFns } from "./SolanLookbackSection.vue?vue&type=template&id=0716b134&scoped=true&"
import script from "./SolanLookbackSection.vue?vue&type=script&lang=ts&"
export * from "./SolanLookbackSection.vue?vue&type=script&lang=ts&"
import style0 from "./SolanLookbackSection.vue?vue&type=style&index=0&id=0716b134&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0716b134",
  null
  
)

export default component.exports